import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Account from './Account';
import Connect from './Connect';
import Contact from './Contact';
import Error from './Error';
import Landing from './Landing';
import Login from './Login';
import Privacy from './Privacy';
import Terms from './Terms';
import { Auth } from '../providers/Auth';
import Log from '../services/Log';
import GuardedRoute from '../Shared/GuardedRoute';
import SkipRoute from '../Shared/SkipRoute';
import ScrollToTop from '../Shared/ScrollToTop';

class Main extends React.Component {
  render() {
    Log.message(`Loading Main`);

    return (
      <HelmetProvider>
        <Auth>
          <Router>
            <ScrollToTop>
              <Routes>
                <Route element={<GuardedRoute />}>
                  <Route path="/account" element={<Account />} />
                  <Route path="/connect/:hash" element={<Connect />} />
                  <Route path="/connect" element={<Connect />} />
                </Route>
                <Route element={<SkipRoute />}>
                  <Route path="/login/:token" element={<Login />} />
                  <Route path="/login" element={<Login />} />
                </Route>
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/error/:code" element={<Error />} />
                <Route path="/error" element={<Error />} />
                <Route path="*" element={<Landing />} />
              </Routes>
            </ScrollToTop>
          </Router>
        </Auth>
      </HelmetProvider>
    );
  }
}

export default Main;
